import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useUiStore = defineStore('ui', () => {
    const isRouteLoading = ref(false)
    const routeLoadingStartedAt = ref<number | null>(null)

    // page-level data loading counter
    const dataLoadingCount = ref(0)

    const startRouteLoading = () => {
        if (!isRouteLoading.value) {
            isRouteLoading.value = true
            routeLoadingStartedAt.value = Date.now()
        }
    }

    const stopRouteLoading = () => {
        isRouteLoading.value = false
        routeLoadingStartedAt.value = null
    }

    const beginDataLoad = () => {
        dataLoadingCount.value += 1
    }

    const endDataLoad = () => {
        dataLoadingCount.value = Math.max(0, dataLoadingCount.value - 1)
    }

    const anyLoading = computed(() => isRouteLoading.value || dataLoadingCount.value > 0)

    return {
        isRouteLoading,
        dataLoadingCount,
        anyLoading,
        startRouteLoading,
        stopRouteLoading,
        beginDataLoad,
        endDataLoad,
    }
})
